import API from '../utils/api';

const loginSuccess = (payload) => ({
    type: 'LOGIN_SUCCESS',
    payload
});

export const setSession = (payload) => dispatch => {
    dispatch(loginSuccess(payload));
}

export const login = (credentials, history, cbFn) => dispatch => {
    const loginPayload = {
        login: credentials.login,
        password: credentials.password,
    }
    return API.post(`/admin/login`, loginPayload).then((response) => {
        console.log("response", response);
        if (response.data && response.data.status === 200) {
            dispatch(loginSuccess(response.data.ResponseData));
            sessionStorage.setItem('user', JSON.stringify(response.data.ResponseData));
            history.push('/dashboard');
            cbFn(response.data.desc);
        } else if (response.data && response.data.status !== 200) {
            cbFn(response.data.desc, true);
        }
    }).catch((error) => {
        //console.log(error);
        cbFn('Unexpected Error', true);
    })
}

export const registration = (user, cbFn) => {
    //console.log(user);
    user.password = window.btoa(user.password);
    user.confirmPassword = window.btoa(user.confirmPassword)
    return API.post(`/admin/services/register`, user).then((response) => {
        if (response.data && response.data.status && response.data.status === "success") {
            cbFn('User is Created Successfully');
        } else if (response.data && response.data.status === "error") {
            cbFn(response.data.desc, true);
        }
    }).catch((error) => {
        cbFn('Unexpected Error', true)
    })
}

export const getCountriesList = async () => {
    return API.get(`/common/countries/get`)
        .then((response) => response)
        .catch((error) => error);
}

export const getOrderSummary = async () => {
    return API.get(`/admin/dashboard/get-order-summary`)
        .then((response) => response)
        .catch((error) => error);
}

export const getCountries = () => {
    return (dispatch) => {
        return API.get(`/misc/services/get/countries`).then((response) => {
            if (response.data && response.data.status && response.data.status === "success") {
                //console.log(response.data.details.countries)
                dispatch({ type: 'LOAD_COUNTRIES', payload: { countries: response.data.details.countries } })
            } else if (response.data && response.data.status === "error") {
                cbFn(response.data.desc, true);
            }
        }).catch((error) => {
            cbFn('Unexpected Error', true)
        })
    }
}

export const userlogout = (userid, cbFn) => {
    return API.post(`/login/services/admin/logout`, userid).then((response) => {
        if (response.data && response.data.status && response.data.status === "success") {
            cbFn(response.data.desc);
            sessionStorage.removeItem('user');
        } else if (response.data && response.data.status === "error") {
            cbFn(response.data.desc, true);
        }
    });
}

export const registerseller = (seller, cbFn) => {
    return API.post(`/food/seller/services/register`, seller).then((response) => {
        if (response.data && response.data.status && response.data.status === "success") {
            cbFn(response.data.desc);
        } else if (response.data && response.data.status === "error") {
            cbFn(response.data.desc, true);
        }
    }).catch((error) => {
        cbFn('Unexpected Error', true)
    })
}
